'use strict';

import search from './modules/search';

export {search};
